import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  startUploadingPicture() {
    const modal = document.getElementById('uploading-picture-modal');
    modal.showModal();
    window.dispatchEvent(new Event('rotated-list:start'));
  }

  stopUploadingPicture() {
    const modal = document.getElementById('uploading-picture-modal');
    modal.close();
    window.location.reload();
  }
}
